module.exports = __webpack_public_path__ + "img/user.a34b12ac.svg";